//All the stuff related to accounts which specifically doesn't have it's own table in the db ( calculated on the fly) can be put here.
import { createReducer, makeActionCreator } from 'utils/reduxCreators';
import {
  fetchBalanceToSettle,
  fetchEstimatedFinalBillDate,
  fetchOutstandingDsFee,
  fetchBalanceToSettleWithoutCancelFee,
} from 'services/accountDetails';

// Outstanding DsFee is different from DsFeeDue. Outstanding considers any future payments in that pay cycle as well.
export const UPDATE_OUTSTANDING_DS_FEE = 'accountMeta/OUTSTANDING_DS_FEE';
export const UPDATE_ESTIMATED_FINAL_BILL_DATE =
  'accountMeta/ESTIMATED_FINAL_BILL_DATE';
export const UPDATE_BALANCE_TO_SETTLE = 'accountMeta/BALANCE_TO_SETTLE';
export const UPDATE_BALANCE_TO_SETTLE_WITHOUT_CANCEL_FEE =
  'accountMeta/BALANCE_TO_SETTLE_WITHOUT_CANCEL_Fee';

const initialState = {
  estimatedFinalBillDate: {
    entities: null,
    currentAccountAdfitNo: '',
  },
  outstandingDsFee: {
    entities: null,
    currentAccountAdfitNo: '',
  },
  balanceToSettle: {
    entities: null,
    currentAccountAdfitNo: '',
  },
  balanceToSettleWithoutCancelFee: {
    entities: null,
    currentAccountAdfitNo: '',
  },
};

export default createReducer(initialState, {
  [UPDATE_ESTIMATED_FINAL_BILL_DATE]: (state, { payload }) => {
    return {
      ...state,
      estimatedFinalBillDate: {
        entities: payload.finalDate,
        currentAccountAdfitNo: payload.adfitNo,
      },
    };
  },
  [UPDATE_OUTSTANDING_DS_FEE]: (state, { payload }) => {
    return {
      ...state,
      outstandingDsFee: {
        entities: payload.fee,
        currentAccountAdfitNo: payload.adfitNo,
      },
    };
  },
  [UPDATE_BALANCE_TO_SETTLE]: (state, { payload }) => {
    return {
      ...state,
      balanceToSettle: {
        entities: payload.balance,
        currentAccountAdfitNo: payload.adfitNo,
      },
    };
  },
  [UPDATE_BALANCE_TO_SETTLE_WITHOUT_CANCEL_FEE]: (state, { payload }) => {
    return {
      ...state,
      balanceToSettleWithoutCancelFee: {
        entities: payload.balance,
        currentAccountAdfitNo: payload.adfitNo,
      },
    };
  },
});

// Final bill date actions.

export const updateFinalBillDate = makeActionCreator(
  UPDATE_ESTIMATED_FINAL_BILL_DATE
);

export const getEstimatedFinalBillDate = (adfitNo) => async (dispatch) => {
  const finalBillDate = await fetchEstimatedFinalBillDate(adfitNo);
  dispatch(
    updateFinalBillDate({
      finalDate: finalBillDate,
      adfitNo,
    })
  );
};

// Outstanding DsFee Actions

export const updateOutstandingDsFee = makeActionCreator(
  UPDATE_OUTSTANDING_DS_FEE
);

export const getOutstandingDsFee = (adfitNo) => async (dispatch) => {
  const { dsFeeDue } = await fetchOutstandingDsFee(adfitNo);
  dispatch(
    updateOutstandingDsFee({
      adfitNo,
      fee: dsFeeDue,
    })
  );
};

// Balance to settle
export const updateBalanceToSettle = makeActionCreator(
  UPDATE_BALANCE_TO_SETTLE
);

export const getBalanceToSettle = (adfitNo) => async (dispatch) => {
  const result = await fetchBalanceToSettle(adfitNo);
  dispatch(
    updateBalanceToSettle({
      adfitNo,
      balance: result,
    })
  );
};

// Balance to settle without cancellation fee. Mainly used in cancellation.

export const updateBalanceToSettleWithOutCancelFee = makeActionCreator(
  UPDATE_BALANCE_TO_SETTLE_WITHOUT_CANCEL_FEE
);

export const getBalanceToSettleWithoutCancelFee =
  (adfitNo) => async (dispatch) => {
    const result = await fetchBalanceToSettleWithoutCancelFee(adfitNo);
    dispatch(
      updateBalanceToSettleWithOutCancelFee({
        adfitNo,
        balance: result,
      })
    );
  };
